export default {
	data: () => ({
		viewportWidth: null,
		defaultBreakpoint: 991
	}),
	methods: {
		setViewportWidth() {
			this.viewportWidth = window.innerWidth;
		}
	},
	computed: {
		isMobile() {
			return this.viewportWidth <= this.defaultBreakpoint;
		},
		isTablet() {
			return this.viewportWidth >= this.defaultBreakpoint;
		}
	},
	created() {
		window.addEventListener('resize', this.setViewportWidth);
		this.setViewportWidth();
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.setViewportWidth);
	}
};
